export default {"src":"/_next/static/media/ic_notification.bf0aa313.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};